export default "__VITE_ASSET__C7zFWQw8__"